import * as React from "react";
import { forwardRef, memo } from "react";
const SvgOutlinedIndicatorIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 4, fill: "#333333" }));
const ForwardRef = forwardRef(SvgOutlinedIndicatorIcon);
const Memo = memo(ForwardRef);
export default Memo;
